import { Affix, Button, Checkbox, Form } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import ModalConfirm from '../../../../components/Shared/modal/confirm';
import ModalDiscardChanges from '../../../../components/Shared/modal/discardChanges';
import useNotify from '../../../../context/Notification/useNotify';
import { useBlocker } from '../../../../util/usePrompt';
import RopaServices from '../../../../services/Ropa.service';
import { ROUTER } from '../../../../constants/router';

export default function Tab3({ referenceDocuments, getRopaDetail }) {
    const [form] = Form.useForm();
    const { t, i18n } = useTranslation();
    const { activityId } = useParams();
    const navigate = useNavigate();
    const notify = useNotify();

    const [reference, setReference] = useState([]);

    // Confirm
    const [openConfirm, setOpenConfirm] = useState(false);
    const [valueSave, setValueSave] = useState();
    const [loading, setLoading] = useState(false);

    // Discard change
    const [change, setChange] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [nextLocation, setNextLocation] = useState(null);
    const [isChangeLocation, setIsChangeLocation] = useState(false);

    useBlocker((nextLocation) => onChangePage(nextLocation), change === true);

    const onChangePage = (nextLocation) => {
        setOpenChange(true);
        setIsChangeLocation(true);
        setNextLocation(nextLocation);
    };

    const handelOk = async () => {
        setOpenChange(false);
        setChange(false);
    };

    const handelOkLocation = async () => {
        setOpenChange(false);
        setChange(false);
        setIsChangeLocation(false);
        await form.resetFields();
        await getRopaDetail();
        await navigate(
            nextLocation.location.pathname + nextLocation.location.search
        );
    };

    const onCancel = (e) => {
        navigate(`${ROUTER.DS_INVENTORY.ROPA}/${activityId}/view?tab=3`);
    };

    const onFinish = () => {
        updateReferenceDocument({
            activityId,
            ...valueSave,
        });
    };

    const updateReferenceDocument = async (payload) => {
        setLoading(true);
        try {
            const { data } = await RopaServices.updateReferenceDocument(
                payload
            );
            if (data?.resultCode === 1) {
                notify({
                    title: t('common.Success'),
                    description: t('Successfully to submitted'),
                });
                setOpenChange(false);
                setChange(false);
                // getDataFlowDetail(businessProcessId);
                setLoading(false);
                setOpenConfirm(false);
                navigate(
                    `${ROUTER.DS_INVENTORY.ROPA}/${activityId}/view?tab=3`
                );
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('Failed to submitted'),
            });
            setOpenConfirm(false);
        }
    };

    useEffect(() => {
        if (referenceDocuments) {
            form.setFieldsValue({
                referenceDocuments: referenceDocuments?.map(
                    (ref) => ref.referenceDocumentId
                ),
            });
        }
    }, [referenceDocuments, form]);

    useEffect(() => {
        const getMasterDocumentType = async () => {
            try {
                const { data } = await RopaServices.getMasterDocumentType(
                    activityId
                );
                if (data?.resultData) {
                    setReference(data?.resultData);
                }
            } catch (error) {
                console.log(error);
            }
        };
        getMasterDocumentType();
    }, [activityId]);

    return (
        <div>
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                layout="vertical"
                form={form}
                onFinish={(value) => {
                    setOpenConfirm(true);
                    setValueSave(value);
                }}
                onFieldsChange={(_, allFields) => {
                    if (allFields.length > 0) {
                        setChange(true);
                    }
                }}
            >
                <Affix offsetTop={60}>
                    <div className="flex justify-end space-x-3">
                        <Button
                            size="large"
                            type="default"
                            className="text-purple-PHX border-purple-PHX w-32"
                            onClick={onCancel}
                        >
                            {t('common.Cancel')}
                        </Button>
                        <Button
                            size="large"
                            type="primary"
                            className="w-32"
                            htmlType="submit"
                        >
                            {t('common.Save')}
                        </Button>
                    </div>
                </Affix>
                <span className="ant-col ant-form-item-label">
                    <label className="ant-form-item-required">
                        <span className="text-[21px] font-bold">
                            {t('dataFlow.references')}
                        </span>
                    </label>
                </span>
                <div className="col-span-2 font-medium pb-4">
                    โปรดระบุชื่อเอกสาร หลักฐานใดๆ หรือฐานข้อมูล
                    ที่เกี่ยวข้องกับข้อมูลส่วนบุคคลใน Data Flow นี้ เช่น
                    สำเนาบัตรประชาชน, Resume, การสนทนาทางโทรศัพท์,
                    ข้อความผ่านทาง facebook, บันทึกการสนทนาเสียง เป็นต้น
                </div>
                <Form.Item
                    name="referenceDocuments"
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Checkbox.Group className="w-full mb-1">
                        {reference?.map((is) => {
                            const docx = is?.documentTypes
                                ?.map((is) => is.name)
                                .join(', ');
                            return (
                                <div key={is.referenceDocumentId}>
                                    <Checkbox
                                        key={is.referenceDocumentId}
                                        value={is.referenceDocumentId}
                                        style={{ lineHeight: '32px' }}
                                    >
                                        {i18n.lang === 'en' ? is.name : is.name}{' '}
                                        {is?.storagePeriod
                                            ? `(${is.storagePeriod})`
                                            : ``}{' '}
                                        {docx && `(${docx})`}
                                    </Checkbox>
                                    <br />
                                </div>
                            );
                        })}
                    </Checkbox.Group>
                </Form.Item>
            </Form>
            <ModalDiscardChanges
                open={openChange}
                handelOk={isChangeLocation ? handelOkLocation : handelOk}
                handelClose={() => setOpenChange(false)}
            />
            <ModalConfirm
                open={openConfirm}
                loading={loading}
                text={t('Do you want to confirm')}
                handelOk={onFinish}
                handelClose={() => setOpenConfirm(false)}
            />
        </div>
    );
}
